<template>
  <div class="viewer-root">
    <main-canvas
      :current-page="currentPage"
      :num-total-pages="numTotalPages"
      :newest-loaded-image-page="newestLoadedImagePage"
      :is-facing-page="isFacingPage"
      :manuscript="manuscript"
      :images="images"
      :zoom-scale="zoomScale"
      :page-direction="pageDirection"
    ></main-canvas>
    <marginals
      :show="isMenuVisible"
      :is-facing-page="isFacingPage"
      :is-preview="isPreview"
      :is-free="isFree"
      :is-ad-shown="isAdShown"
      :current-timestamp="currentTimestamp"
      :custom-button="customButton"
      :current-page="currentPage"
      :num-total-pages="numTotalPages"
      :zoom-scale="zoomScale"
      :book="book"
      :manuscript="manuscript"
      :page-direction="pageDirection"
      @purchase="purchase"
    ></marginals>
    <story-modal
      :show="modals.showStoryModal"
      :book="book"
      :authors="authors"
      :num-total-pages="numTotalPages"
    ></story-modal>
    <tutorial-modal
      :show="modals.showTutorialModal"
    ></tutorial-modal>
    <nopage-modal
      :show="modals.showNopageModal"
    ></nopage-modal>
    <lefttoright-modal
      :show="modals.showLefttorightModal"
    ></lefttoright-modal>
    <finish-modal
      :show="modals.showFinishModal"
      :book="book"
      :next-book="nextBook"
      :currency="currency"
      :is-preview="isPreview"
      :is-free="isFree"
      :is-ad-shown="isAdShown"
      :current-timestamp="currentTimestamp"
      :custom-finish="customFinish"
      @purchase="purchase"
      @read="read"
      @preview="preview"
      @backstore="backstore"
      @backmanga="backmanga"
      :banned="banned"
    ></finish-modal>

    <template v-if="nextBook">
      <tax-calculation-modal></tax-calculation-modal>
      <payment-modal
        :show="showPaymentModal"
        :payment="payment"
        :terms-html="termsHtml"
        :support-url="supportUrl"
        @registerdPaymentMethod="registerdPaymentMethod"
        @hidePaymentModal="hidePaymentModal"
      ></payment-modal>
      <purchase-single-modal
        @confirm="confirm"
        @cancel="showConfirmationModal = false"
        :is-shown="showConfirmationModal"
        :is-requesting="isRequesting"
        :error="error"
        :item="nextBook"
        :currency="currency"
        :is-delegated="isDelegated"
      ></purchase-single-modal>
      <purchase-finish-modal
        @read="read"
        @close="showPurchaseFinishModal = false"
        :is-shown="showPurchaseFinishModal"
        :is-single="true"
        :title="nextBook.title"
        :numberingText="nextBook.numberingText"
        :onSaleAt="nextBook.onSaleAt"
        :closeSaleAt="nextBook.closeSaleAt"
        :currentTimestamp="currentTimestamp"
      ></purchase-finish-modal>
    </template>
  </div>
</template>

<style scoped>
/* for  firefox jira ANM-1054 */
.viewer-root{
  position: fixed;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
</style>

<script type="text/babel">
  import * as types from "./store/mutation-types"
  import { mapGetters, mapState, mapActions } from "vuex"
  import MainCanvas from "./organisms/MainCanvas.vue"
  import Marginals from "./organisms/Marginals.vue"
  import StoryModal from "./organisms/StoryModal.vue"
  import FinishModal from "./organisms/FinishModal.vue"
  import TutorialModal from "./organisms/TutorialModal.vue"
  import NopageModal from "./organisms/NopageModal.vue"
  import PaymentModal from "./organisms/PaymentModal.vue"
  import LefttorightModal from "./organisms/LefttorightModal.vue"

  import PurchaseSingleModal from "../../../../components/manga_store/pc/molecules/PurchaseSingleModal.vue"
  import PurchaseFinishModal from "../../../../components/manga_store/pc/molecules/PurchaseFinishModal.vue"

  import {NAMESPACE as TAX_NAMESPACE} from "../../../../components/manga_store/common/stores/tax_calculation_modal"
  import * as taxCalculationModalTypes from "../../../../components/manga_store/common/stores/tax_calculation_modal/mutation-types"
  import TaxCalculationModal from "../../../../components/manga_store/pc/organisms/tax_calculation_modal/TaxCalculationModal.vue"

  const _ = window._

  export default {
    components: {
      MainCanvas,
      Marginals,
      StoryModal,
      FinishModal,
      TutorialModal,
      NopageModal,
      PaymentModal,
      PurchaseSingleModal,
      PurchaseFinishModal,
      TaxCalculationModal,
      LefttorightModal,
    },
    data() {
      return {
        showConfirmationModal: false,
        showPurchaseFinishModal: false,
        isRequesting: false,
        error: null,
      }
    },
    computed: {
      ...mapState([
        "banned",

        "loginUrl",

        "currentPage",
        "numTotalPages",
        "isHoverCanvas",
        "isFacingPage",
        "zoomScale",
        "pageDirection",
        "newestLoadedImagePage",

        "modals",

        "book",
        "nextBook",
        "currency",
        "authors",
        "manuscript",
        "images",
        "isPreview",
        "isFree",
        "isAdShown",
        "currentTimestamp",
        "customButton",
        "customFinish",
        "currency",
        "showBuyButton",
        "payment",
        "termsHtml",
        "supportUrl",
      ]),
      ...mapState(`${TAX_NAMESPACE}`, {
        isDelegated: state => state.isDelegated,
        showPaymentModal: state => state.modals.showPaymentModal,
      }),
      isMenuVisible() {
        return this.modals.showFinishModal || !this.isHoverCanvas
      }
    },
    created() {
      // 45 秒ごとに署名付き URL のパラメータを更新する
      setInterval(() => {
        this.$store.dispatch(types.RENEW_TOKEN)
      }, 45000)
    },
    watch: {
      currentPage() {
        // 事前に数ページ前後の画像をロードする
        this.loadImages(this.$store)

        // 読んだページを保存
        // 試し読みでは読んだページを保存しない
        if (!this.isPreview) {
          this.bookmark(this.$store)
        }
      }
    },
    methods: {
      // 画像をロードする
      // ページを短い間隔で移動した時に都度リクエストを送らないように debounce を使用
      loadImages: _.debounce((store) => {
        store.dispatch(types.LOAD_IMAGES)
      }, 300),

      // 読んだページを保存するリクエストを送信する
      // ページを短い間隔で移動した時に都度リクエストを送らないように debounce を使用
      bookmark: _.debounce((store) => {
        store.dispatch(types.BOOKMARK)
      }, 1000),

      /**
       * 最後のページで購入する
       */
      async purchase() {
        this.$store.commit(types.HIDE_FINISH_MODAL)

        if (this.loginUrl) {
          location.href = this.loginUrl
        } else {
          this.isRequesting = true

          const taxInfo = await this.$store.dispatch(`${TAX_NAMESPACE}/${taxCalculationModalTypes.GET_TAX}`, {
            itemType: this.nextBook.itemType,
            itemIds: [this.nextBook.id],
            itemTotalAmount: this.nextBook.salePrice || this.nextBook.price,
            selectedCountry: null
          })
          this.$store.commit(types.SET_TAX, taxInfo)

          this.isRequesting = false
          this.showConfirmationModal = true
        }
      },

      /**
       * 購入確定する
       */
      async confirm() {
        this.error = null
        this.isRequesting = true
        try {
          await this.$store.dispatch(types.PURCHASE)
          this.showConfirmationModal= false
          this.showPurchaseFinishModal = true
          // 購入時にPreviewで読んだページを保存
          this.bookmark(this.$store)
        } catch (e) {
          this.isRequesting = false
          this.error = e.message
        }
      },

      backstore() {
        location.href = this.nextBook.url
      },
      backmanga() {
        location.href = this.nextBook.url + '?goto=manga'
      },
      read() {
        location.href = this.nextBook.viewerUrl
      },
      preview() {
        location.href = this.nextBook.previewUrl
      },
      hidePaymentModal() {
        this.$store.commit(`${TAX_NAMESPACE}/${taxCalculationModalTypes.SHOW_PAYMENT_MODAL}`, false)
      },
      registerdPaymentMethod() {
        this.purchase()
        this.hidePaymentModal()
      },
    },
  }
</script>
